// Reveal-mode selection math, kept pure so it can be unit-tested without a
// ReactFlow/store harness. In present mode each step lights its *entire* group
// at once (no per-item drip): an item is revealed once the pointer reaches its
// step. Items with revealStep 0 are never sequenced.

export interface RevealItem {
  id: string;
  revealStep: number;
}

/**
 * The set of item ids visible at a given reveal pointer — every sequenced item
 * whose step is > 0 and has been reached (revealStep <= pointer). Whole group
 * per step; order-independent.
 */
export function computeRevealedSet(items: RevealItem[], pointer: number): Set<string> {
  const revealed = new Set<string>();
  if (pointer <= 0) return revealed;
  for (const item of items) {
    if (item.revealStep > 0 && item.revealStep <= pointer) revealed.add(item.id);
  }
  return revealed;
}
